import { InjectionToken } from '@angular/core';

export interface LoggingConfig {
  ApplicationInsights: {
    InstrumentationKey: string;
    ApplicationName: string;
    CloudRoleName: string;
  };
}

export const LOG_CONFIG = new InjectionToken<LoggingConfig>('app.config');

const DEFAULT_LOG_CONFIG: LoggingConfig = {
  ApplicationInsights: {
    InstrumentationKey: '',
    ApplicationName: '',
    CloudRoleName: '',
  },
};

export function getLogConfigWithDefaults(config: LoggingConfig): LoggingConfig {
  return { ...DEFAULT_LOG_CONFIG, ...config } as LoggingConfig;
}
